import { Achievement } from './types';

export const ACHIEVEMENTS: Achievement[] = [
  {
    id: 'tower_master',
    name: 'Tower Master',
    description: 'Reach Level 10 in Word Builder',
    icon: 'fa-chess-rook',
    color: 'indigo'
  },
  {
    id: 'speed_demon',
    name: 'Speed Demon',
    description: 'Achieve a reaction time under 200ms in Reaction Test',
    icon: 'fa-bolt',
    color: 'amber'
  },
  {
    id: 'math_wizard',
    name: 'Math Wizard',
    description: 'Score over 1000 points in Quick Math',
    icon: 'fa-calculator',
    color: 'emerald'
  },
  {
    id: 'zen_master',
    name: 'Zen Master',
    description: 'Complete a full 1-minute session of Resonance Breathing',
    icon: 'fa-lotus',
    color: 'purple'
  },
  {
    id: 'labyrinth_conqueror',
    name: 'Labyrinth Conqueror',
    description: 'Clear a Hard difficulty level in Labyrinth',
    icon: 'fa-dungeon',
    color: 'rose'
  },
  {
    id: 'sudoku_master',
    name: 'Sudoku Master',
    description: 'Complete a Hard difficulty Sudoku puzzle',
    icon: 'fa-table-cells',
    color: 'cyan'
  },
  {
    id: 'fruit_ninja',
    name: 'Fruit Ninja',
    description: 'Score over 5000 points in Fruit Vortex',
    icon: 'fa-apple-whole',
    color: 'orange'
  },
  {
    id: 'binary_pro',
    name: 'Binary Pro',
    description: 'Score over 2000 points in Binary Dash',
    icon: 'fa-code-branch',
    color: 'blue'
  },
  {
    id: 'memory_god',
    name: 'Memory God',
    description: 'Reach Level 15 in Memory Matrix',
    icon: 'fa-brain',
    color: 'teal'
  },
  {
    id: 'color_commander',
    name: 'Color Commander',
    description: 'Score over 3000 points in Color Clash',
    icon: 'fa-palette',
    color: 'pink'
  },
  {
    id: 'tetris_legend',
    name: 'Tetris Legend',
    description: 'Clear 4 lines at once (Tetris) in Neon Tetris',
    icon: 'fa-shapes',
    color: 'fuchsia'
  },
  {
    id: 'grammar_guru',
    name: 'Grammar Guru',
    description: 'Complete a round of Grammar Guardian with 100% accuracy',
    icon: 'fa-book',
    color: 'emerald'
  }
];
